import { EVENT_BUS_MODAL_CONTEXT } from '@/src/shared/config'
import { eventBus } from '@/src/shared/lib/eventBus'

export function name(target: string, command: string) {
  return eventBus.nameGenerate(EVENT_BUS_MODAL_CONTEXT, target, command)
}
